import axios from "axios";
import { CaptureResponse } from "../../types/model/capture";
import { SessionStore } from "../../types/store";
import { newAbortSignal } from "../../utils";
import { PaginatedResponse } from "../../types/interfaces/app/PaginatedResponse";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/captures`;

export const listCaptures = async (
  entityId?: number,
  managementUnitId?: number,
  search?: string,
  militaryMap?: string,
  limit?: number,
  offset?: number,
  writeAccessOnly?: boolean,
): Promise<PaginatedResponse<CaptureResponse>> => {
  const session: SessionStore | undefined = JSON.parse(
    localStorage.getItem("session") || "{}",
  );

  const res = await axios.get<CaptureResponse[]>(`${BASE_URL}`, {
    headers: {
      "content-type": "application/json",
      "x-access-token": session?.accessToken,
    },
    params: { entityId, managementUnitId, search, militaryMap, limit, offset, writeAccessOnly },
    timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
    signal:
      AbortSignal.timeout === undefined
        ? newAbortSignal(Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`))
        : AbortSignal.timeout(Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`)),
  });

  return {
    data: res.data,
    total: Number.parseInt(res.headers["x-total-count"]),
  };
};
